import React from "react"
import MoonImg from "../../../../../assets/avia/ticket/moon.png"
import FlightRoute from "./FlightRoute"
import { customFormatDateV2 } from "../../utils/date/common"
import { cn } from "../../../../../lib"

const SingleTicketCard = ({ card, locale, t, isSingleCard = true, airlines }) => {
  const logoUrl = `https://images.kiwi.com/airlines/64/${card?.airlineCode}.png`
  const fallbackUrl = `https://airlabs.co/img/airline/m/${card?.airlineCode}.png`

  const airlineFromList = airlines?.find(
    (airline) => airline?.iata === card?.airlineCode
  )

  const airlineName = airlineFromList?.name || card?.airline

  return (
    <div
      className={cn(
        "h-52 relative flex flex-col w-full justify-center px-[19px]",
        isSingleCard && "h-[230px]"
      )}
    >
      <div className={isSingleCard && "pb-8"}>
        <div className="absolute top-3 left-3 h-5 flex gap-1 items-center">
          {/* {card.isNight && <img className="w-5 h-5" src={MoonImg} alt="night flight" />} */}
          {!card.isDirect && <span className="text-sm">{t("transport.transfer")}</span>}
        </div>

        <div className="absolute top-0 max-w-72 w-full h-8 rounded-b-sm p-2 bg-second-success/30 left-1/2 -translate-x-1/2 text-second-success flex items-center justify-center z-10 gap-1">
          <span>{card.label}:</span>
          <span>{customFormatDateV2(card.date, locale)}</span>
        </div>

        <div className="flex items-center gap-4">
          <div className="rounded-full w-20 h-20 flex-shrink-0 overflow-hidden bg-white border border-gray-200 p-2">
            <img
              src={logoUrl}
              alt={airlineName}
              onError={(e) => {
                e.currentTarget.src = fallbackUrl
              }}
              className="w-full h-full object-contain"
            />
          </div>

          <div className="flex-1 min-w-0">
            <FlightRoute
              isDirect={card.isDirect}
              from={{
                code: card.from.code,
                city: card.from.city,
                time: card.time.departure,
              }}
              to={{
                code: card.to.code,
                city: card.to.city,
                time: card.time.arrival,
              }}
              duration={card.duration}
              stops={card.stops}
              date={card.date}
            />
          </div>
        </div>

        <div className="mt-1">
          <p className="font-medium text-[18px]">{airlineName}</p>
          {/* <span className="text-dark-violet text-[15px] font-medium">{card.classSeat}</span> */}
        </div>
      </div>

      {isSingleCard && (
        <div className="absolute bottom-10 left-4 right-0 border-b border-light-gray/30" />
      )}
    </div>
  )
}

export default SingleTicketCard